<template>
  <div class="page-container" :class="{ 'page-container--with-sidebar': isSidebarPresent }">
    <div class="admin__header">
      <h1 class="page-title">Uredi Blog</h1>
      <v-button class="delete-button" :disabled="isLoading" @click="onDelete" background-color="red" outlined>Izbriši</v-button>
    </div>
    <blog-post-form v-if="blogPost" v-show="!isLoading" :blog-post="blogPost" @submit="submitBlogPost" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BlogPostForm from './forms/BlogPostForm'
import VButton from 'design-system/VButton.vue'
import prompt from 'design-system/components/prompt/prompt'

export default {
  props: {
    id: { type: [String, Number], required: true },
  },
  components: {
    BlogPostForm,
    VButton,
  },
  created () {
    this.initialize(this.id)
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState(['isLoading']),
    ...mapState('admin/blogPosts/forms', ['blogPost']),
  },
  methods: {
    ...mapActions('admin/blogPosts/forms', ['initialize', 'reset', 'submitBlogPost', 'deleteBlogPost']),
    async onDelete () {
      const result = await prompt.okText('Izbriši').confirm('Res želite izbrisati blog? Akcija bo nepovratno izbrisala blog vključno z vso vsebino.')
      if (result) {
        this.deleteBlogPost(this.id)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/admin_common';
@import '@/components/common';
</style>
